import React from "react";
import { Select, Checkbox } from "antd";
import { ReactComponent as SelectIcon } from "../../../assets/svgs/select-icon.svg";

const { Option } = Select;

const CustomSelect = ({
  options,
  mode = "single",
  placeholder = "Select",
  width = "100%",
  height = "30px",
  value,
  onChange,
  loading = false,
  disabled = false,
}) => {
  const handleChange = (selectedValues) => {
    if (mode === "multiple") {
      if (selectedValues.includes("all_section")) {
        const allSectionValues = options
          .filter((opt) => opt.value !== "all_section")
          .map((opt) => opt.value);
        onChange(allSectionValues);
      } else {
        onChange(selectedValues);
      }
    } else {
      onChange(selectedValues); // Single select, value is string
    }
  };

  return (
    <Select
      mode={mode === "multiple" ? "multiple" : undefined}
      placeholder={placeholder}
      suffixIcon={<SelectIcon />}
      style={{ width, minHeight: height  }}
      value={value}
      onChange={handleChange}
      optionLabelProp="label"
      loading={loading}
      disabled={disabled}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value} label={option.label}>
          {mode === "multiple" ? (
            option.value !== "all_section" ? (
              <Checkbox checked={Array.isArray(value) && value.includes(option.value)}>
                {option.label}
              </Checkbox>
            ) : (
              <div>{option.label}</div>
            )
          ) : (
            option.label
          )}
        </Option>
      ))}
    </Select>
  );
};

export default CustomSelect;
